import { render, staticRenderFns } from "./ErrorTemplate.vue?vue&type=template&id=397ac7d3"
import script from "./ErrorTemplate.vue?vue&type=script&lang=ts"
export * from "./ErrorTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ErrorTemplate.vue?vue&type=style&index=0&id=397ac7d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports